import Vue from "vue"
Vue.filter('uppercase', function (value) {
    if (!value) return ''
    
    return value.toUpperCase().toString()
  })
  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })
  Vue.filter('tableheader', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })
Vue.filter("first2Chars", str => str.substring(0, 2))
Vue.filter("last2Chars", str => str.substring(str.length - 2))
Vue.filter('formatPrice', function (value) {
    let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  })

  export default {}